
























import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class AccordionTs extends Vue {

  public name: string = "Accordion";

  @Prop({required: true})
  public mname!: string;

  @Prop({required: false})
  public selected!: boolean;

  @Prop({required: false, default: '#'})
  public resourceBaseUrl!: string;

  @Prop({required: false, default: 0})
  public objectId!: number;


  private title: string = '';
  private isActive: boolean = false;

  private get href(): any {

    return '#' + this.mname.toLowerCase().replace(/ /g, '-');

  }

  private selectAccordion(selectedAccordion: any): void {

    if (this.isActive) {

      this.isActive = false;


    } else {

      this.isActive = true;

      //this.$parent.selectAccordion(selectedAccordion);

    }

  }

  mounted() {

    this.isActive = this.selected;

  }


}
